import { useEffect, useState } from 'react';
import { timeToSeconds } from '../../Player/PlayerServices';
import { ActionBarBtn } from '../../Player/styles';
import { __t } from '../../../i18n';
import UsePlayerProps from '../../../Store/usePlayerProps';
import IconSkipNext from '../../../icons/IconSkipNext';

export default function SkipIntro({ player }: { player: HTMLVideoElement }) {
  const contentConfigs = UsePlayerProps((state) => state.playerState.contentConfigs);

  const firstTitration = contentConfigs?.titrations?.find((item) => item?.video_file_titrations_type === 'start');
  const [showFirstTitration, setShowFirstTitration] = useState<boolean>(false);

  useEffect(() => {
    player.addEventListener('timeupdate', handleShow);
    return () => {
      player.removeEventListener('timeupdate', handleShow);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player]);

  const handleShow = () => {
    firstTitration && setShowFirstTitration(timeToSeconds(firstTitration.start_time) < player.currentTime &&
      player.currentTime < timeToSeconds(firstTitration.end_time));
  };

  const handleSkipIntro = () => {
    if (showFirstTitration) {
      player.currentTime = timeToSeconds(firstTitration?.end_time);
      setShowFirstTitration(false);
    }
  };

  return (
    <>
      {showFirstTitration && <ActionBarBtn onClick={handleSkipIntro}>
        {__t('player.skip_intro')}
        <IconSkipNext />
      </ActionBarBtn>}
    </>
  );
}
